<script setup lang="ts">
  import type { OrderDetailsDelivery } from '~/types/ecommerce/generated.codegen';

  const props = defineProps<{
    delivery: OrderDetailsDelivery;
  }>();

  const recipient = computed(() => props.delivery?.recipient);

  const ruralZone = computed(() =>
    props.delivery?.address.rural_zone ? 'Sim' : 'Não',
  );

  const completeAddress = computed(() => {
    const {
      street,
      number,
      neighborhood,
      complement,
      zip_code: zipCode,
      city,
      region,
    } = props.delivery.address;
    return `${street} ${number ? `, ${number}` : ''} - ${neighborhood} ${
      complement ? `- ${complement}` : ''
    } - CEP ${zipCode} - ${city} - ${region}`;
  });
</script>

<template>
  <div class="delivery-details-order-cif">
    <div class="title-address-order">
      <span class="section-heading">Endereço de entrega</span>
    </div>
    <div class="infos-address">
      <div class="address-column">
        <div class="body-address">
          {{ completeAddress }}
        </div>
        <div class="body-address rural">
          Entrega em zona rural: {{ ruralZone }}
        </div>
      </div>

      <div class="address-column">
        <div class="title-address">Contato para entrega</div>
        <div class="body-address">
          <div>
            {{ recipient?.name }}
          </div>
          <div class="contact">
            {{ applyMask(recipient?.phone || '', '## #####-####') }}
          </div>
          <div class="contact">
            {{ recipient?.email }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .delivery-details-order-cif {
    @apply p-2xs;
    @apply md:site:p-2xs sm:site:p-2xs xsm:site:px-micro xsm:site:py-2xs;
    @apply border-a-xs border-neutral-high-medium rounded-lg;

    > .title-address-order {
      @apply flex gap-nano align-middle xsm:site:flex-col md:site:gap-micro;

      > .section-heading {
        @apply fonts-heading-h3 lg:site:text-xs;
      }
    }

    > .infos-address {
      @apply mt-2xs flex flex-col gap-2xs xsm:site:mt-4xs;

      .address-column {
        @apply flex-1;

        > .title-address {
          @apply mb-micro block fonts-body-large-bold;
        }

        > .body-address {
          @apply fonts-body-medium-regular;

          & + .rural {
            @apply mt-nano;
          }

          > .contact {
            @apply mt-nano;
          }
        }
      }
    }
  }
</style>
